import {
  SET_LABEL
} from '../types';

export const setLabel = (label) => ({
  type: SET_LABEL,
  payload: { label },
});
